/* unplugin-vue-components disabled */import script from "./albumManager.vue?vue&type=script&setup=true&lang=js"
export * from "./albumManager.vue?vue&type=script&setup=true&lang=js"

import "./albumManager.vue?vue&type=style&index=0&id=c6fe3f18&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6fe3f18"]])

export default __exports__